
const capitalize = (value: any) => {
    let splitted = value.split(' ');
    let formatado = '';
    splitted.forEach((element: string) => {
        formatado = formatado.concat(' ' + element.charAt(0).toUpperCase() + element.slice(1));
    });
    return formatado;
};

const formatCep = (value?: string) => {
    const raw = (value || '').replace(/\D/g, '');
    if (raw.length >= 8) {
        return raw.replace(/(\d{5})(\d{3}).*/, '$1-$2');
    }
    return value || '';
}

export const enderecoFormatado =
    (lgr: string, nro: string, bairro: string, municipio: string, uf: string, complemento?: string, cep?: string, referencia?: string, linhasSeparadas: boolean = false) => {
        const logradouro = capitalize((lgr || '').toLowerCase());
        const numero = capitalize((nro || '').toLowerCase());
        const complementoFmt = complemento ? capitalize((complemento || '').toLowerCase()) : '';
        const referenciaFmt = referencia ?? '';
        const bairroFmt = capitalize((bairro || '').toLowerCase());
        const municipioFmt = capitalize((municipio || '').toLowerCase());

        if (linhasSeparadas) {
            const linha1 = `${logradouro}, ${numero}`;
            const linha2 = complementoFmt ? `${complementoFmt}` : '';
            const linha3 = referenciaFmt ? `Referência: ${referenciaFmt}` : '';
            const linha4 = `${bairroFmt}, ${municipioFmt}`;
            const linha5 = cep ? `${formatCep(cep)}` : '';
            return [linha1, linha2, linha3, linha4, linha5].filter(Boolean).join('\n');
        }

        // Em linha única, formatado corretamente
        const cepFmt = cep ? formatCep(cep) : '';
        const partes = [
            `${logradouro}, ${numero}`,
            complementoFmt && `${complementoFmt}`,
            `${bairroFmt}, ${municipioFmt}${uf ? ` - ${uf}` : ''}`,
            referenciaFmt && `Ref.: ${referenciaFmt}`,
            cepFmt && `${cepFmt}`
        ].filter(Boolean);
        return partes.join(' - ');
    }